"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALLBACK_LOCALE = void 0;
/**
 * The fallback locale should be en-us. In case locale is not provided,
 * it should fall back to en-us by default
 */
var FALLBACK_LOCALE = 'en-us';
exports.FALLBACK_LOCALE = FALLBACK_LOCALE;